export class CLazyHandler {
  constructor(element, fn, options) {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some(({ isIntersecting }) => isIntersecting)) {
        observer.disconnect()
        fn()
      }
    }, options)

    observer.observe(element)
  }
}

export default class LazyLoadEmbed {
  constructor() {
    this.figures = document.querySelectorAll('.block-embed_block figure')

    this.figures.forEach((e) => {
      const template = e.querySelector('template')

      if (template)
        new CLazyHandler(e, () => {
          e.append(template.content)
          template.remove()
        })
    })
  }
}
